import { TEventGetAllPayload } from './../types/@event';
import axios from 'axios';
import { URI_EVENT } from '../helpers/constans';
import { IEventGetResponseOk, IEventPutPayload, IEventPutResponseOk } from '../types/@event';

export const fetchEventGet = (page: TEventGetAllPayload): Promise<IEventGetResponseOk> => {
  return axios.get(`${URI_EVENT}?page=${page}`);
};

export const fetchEventPut = (payload: IEventPutPayload): Promise<IEventPutResponseOk> => {
  return axios.post(`${URI_EVENT}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const fetchEventStatusConfig = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-config`);
};

export const fetchEventStatusPhrase = (
  eventId: string,
  payload: { context: string; refinement: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-phrase`, payload);
};

export const fetchEventStatusApply = (
  eventId: string,
  payload: { ownerIds: string[]; text: string },
) => {
  return axios.post(`${URI_EVENT}/${eventId}/status-apply`, payload);
};

export const fetchEventStatusPlayers = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/status-players`);
};
export const fetchEventPosts = (eventId: string) => {
  return axios.get(`${URI_EVENT}/${eventId}/posts`);
};

